module.exports = __webpack_public_path__ + "static/media/Frame-12.25918828.svg";